import { useRef, useState } from "react"
import { Box, Button, Menu, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { TruncatedTypography } from "lib/@components/truncated-typography"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { RegimeMenuItem } from "./regime-menu-item"
import { goToRegime } from "./go-to-regime"

export function MultipleRegimesDropdown({ regimes = [], regimeCount }) {
    const anchorRef = useRef(null)
    const [open, setOpen] = useState(false)

    return (
        <Box ref={anchorRef} display="inline-flex" sx={{ maxWidth: "100%", minWidth: 0 }}>
            <Button
                color="inherit"
                sx={{
                    px: 1,
                    py: 0.5,
                    minWidth: 0,
                    maxWidth: "100%",
                    justifyContent: "flex-start",
                    textTransform: "none",
                    borderRadius: 999,
                    "&:hover": { bgcolor: "action.hover" },
                }}
                size="small"
                onClick={(e) => {
                    e.stopPropagation()
                    setOpen((v) => !v)
                }}
                startIcon={<Iconify icon="pajamas:issue-type-maintenance" />}
                endIcon={<Iconify icon="mdi:arrow-drop-down" />}
                aria-haspopup="menu"
                aria-expanded={open ? "true" : "false"}
                data-cy="regimes-for-register-trigger"
            >
                <If truthy={regimeCount === 1}>
                    <TruncatedTypography variant="body2" sx={{ whiteSpace: "nowrap", minWidth: 0 }}>
                        {(regimes[0]?.title ?? "").split(": ").slice(1).join(": ") || regimes[0]?.title}
                    </TruncatedTypography>
                    <Else>
                        <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
                            {regimeCount} Regimes
                        </Typography>
                    </Else>
                </If>
            </Button>
            <Menu
                open={open}
                anchorEl={anchorRef.current}
                onClose={close}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
                slotProps={{
                    list: { "aria-label": "Regimes for register", dense: true },
                    paper: { sx: { borderRadius: 1.5, minWidth: 220, p: 0.5 } },
                }}
            >
                {regimes.map(regimeMenuItem)}
            </Menu>
        </Box>
    )

    function regimeMenuItem(regime) {
        return <RegimeMenuItem key={regime.regimeId} regime={regime} onSelect={selectRegime} />
    }

    function selectRegime(regime) {
        close()
        goToRegime(regime)
    }

    function close() {
        setOpen(false)
    }
}
